import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function CriticalPinDialog({ open, onClose, onSubmit, actionLabel, busy }) {
    const [pin, setPin] = useState("");

    const submit = () => {
        if (!pin.trim()) return;
        onSubmit(pin.trim());
        setPin("");
    };

    return (
        <Dialog open={open} onOpenChange={(v) => { if (!v) { setPin(""); onClose(); } }}>
            <DialogContent className="max-w-sm" data-testid="critical-pin-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 font-display">
                        <ShieldAlert className="h-5 w-5 text-destructive" /> Kritik İşlem Onayı
                    </DialogTitle>
                    <DialogDescription>
                        <span className="font-semibold text-foreground">{actionLabel}</span> kritik bir işlemdir.
                        Devam etmek için kritik işlem şifresini girin. Bu işlem denetim kaydına alınır.
                    </DialogDescription>
                </DialogHeader>
                <Input
                    type="password"
                    value={pin}
                    onChange={(e) => setPin(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && submit()}
                    placeholder="Kritik işlem şifresi"
                    autoFocus
                    data-testid="critical-pin-input"
                />
                <DialogFooter>
                    <Button variant="outline" onClick={() => { setPin(""); onClose(); }} data-testid="critical-pin-cancel">Vazgeç</Button>
                    <Button onClick={submit} disabled={!pin.trim() || busy} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="critical-pin-submit">
                        Onayla ve Uygula
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
